(function () {
  function initKit() {
    var root = document.querySelector('[data-kit-main]');
    if (!root || root.dataset.kitInit === '1') return;
    root.dataset.kitInit = '1';
    var dataEl = root.querySelector('#kit-data');
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('kit-data parse failed', e); return; }
    var COMPUTED = DATA.mode === 'computed';
    var money = function (cents) {
      return (DATA.currency === 'USD' ? '$' : '') + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    function parseSeats(title) { var m = (title || '').match(/\d+/); return m ? parseInt(m[0], 10) : 1; }
    var state = {
      variant: DATA.variants.find(function (v) { return v.id === DATA.currentVariantId; }) || DATA.variants[0],
      seatCount: 1,
      addons: {},
      addonAlt: {},
      lineAlt: {},
      extras: {},
      lineQty: {},
      dirty: {}
    };
    function tierSeats() { return parseSeats(state.variant.title); }
    state.seatCount = tierSeats();
    function seats() { return state.seatCount; }
    function scales(scope) { return scope === 'per_device' || scope === 'per_seat'; }
    function scaledQty(line, count) {
      var q = line.defaultQty || 1;
      if (scales(line.scope)) q = q * count;
      if (line.scope === 'per_block' && line.blockSize > 0) q = Math.ceil((q * count) / line.blockSize);
      return q;
    }
    function baseline(line) { return scaledQty(line, seats()); }
    function tierBase(line) { return scaledQty(line, tierSeats()); }
    function lineOpt(i) {
      var line = DATA.included[i];
      var opts = line.options || [];
      var idx = state.lineAlt[i] || 0;
      return opts[idx] || opts[0] || { title: line.title, variantId: line.variantId, priceCents: line.priceCents, image: '' };
    }
    function chargeUnits(line, i) {
      if (!line.variantId) return 0;
      if (COMPUTED) return state.lineQty[i] || 0;
      return Math.max(0, baseline(line) - tierBase(line)) + (state.extras[i] || 0);
    }
    function addonOpt(i) {
      var a = DATA.addons[i];
      var opts = a.options || [];
      var idx = state.addonAlt[i] || 0;
      return opts[idx] || opts[0] || { title: a.title, variantId: a.variantId, priceCents: a.priceCents, image: '' };
    }
    function initLines(clearDirty) {
      DATA.included.forEach(function (line, i) {
        if (clearDirty) { state.dirty[i] = false; state.extras[i] = 0; }
        if (!state.dirty[i]) state.lineQty[i] = baseline(line);
        if (state.extras[i] == null) state.extras[i] = 0;
      });
    }
    function renderIncluded() {
      root.querySelectorAll('[data-kit-line]').forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-kit-line'), 10);
        var line = DATA.included[idx];
        if (!line) return;
        var base = baseline(line);
        var qEl = row.querySelector('[data-kit-line-qty]');
        if (qEl) qEl.textContent = '\u00d7' + base;
        var input = row.querySelector('[data-kit-inc-input]');
        if (input) {
          if (COMPUTED) { input.min = 0; input.value = state.lineQty[idx]; }
          else { input.min = base; input.value = base + (state.extras[idx] || 0); }
        }
        var baseEl = row.querySelector('[data-kit-line-base]');
        if (baseEl) baseEl.textContent = base;
        var opt = lineOpt(idx);
        var lp = row.querySelector('[data-kit-line-price]');
        if (lp && DATA.showPrices) lp.textContent = money(opt.priceCents);
        if ((line.options || []).length > 1) {
          var nameEl = row.querySelector('[data-kit-line-name]');
          if (nameEl) nameEl.textContent = opt.title;
          var imgEl = row.querySelector('[data-kit-line-img]');
          if (imgEl && opt.image) imgEl.src = opt.image;
        }
        row.querySelectorAll('[data-kit-line-alt]').forEach(function (p) {
          p.classList.toggle('is-active', parseInt(p.getAttribute('data-kit-line-alt'), 10) === (state.lineAlt[idx] || 0));
        });
      });
      var seatInput = root.querySelector('[data-kit-seats] input');
      if (seatInput) { seatInput.min = COMPUTED ? 1 : tierSeats(); seatInput.value = state.seatCount; }
    }
    function renderAddons() {
      root.querySelectorAll('[data-kit-addon]').forEach(function (card) {
        var i = parseInt(card.getAttribute('data-kit-addon'), 10);
        var a = DATA.addons[i];
        if (!a) return;
        var qty = state.addons[i] || 0;
        var on = qty > 0;
        var opt = addonOpt(i);
        var multi = (a.options || []).length > 1;
        var t = card.querySelector('[data-kit-addon-toggle]');
        if (t) {
          t.textContent = on ? (t.getAttribute('data-added') || 'Added \u2713') : (t.getAttribute('data-add') || 'Add');
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        var nameEl = card.querySelector('[data-kit-addon-name]');
        if (nameEl) {
          if (a.topic) nameEl.textContent = a.topic;
          else nameEl.textContent = multi && on ? opt.title : a.title;
        }
        var imgEl = card.querySelector('[data-kit-addon-img]');
        if (imgEl && opt.image) imgEl.src = opt.image;
        var selEl = card.querySelector('[data-kit-addon-selected]');
        if (selEl) {
          if (a.topic && multi && on) {
            selEl.textContent = (selEl.getAttribute('data-prefix') || '') + opt.title;
          } else {
            selEl.textContent = '';
          }
        }
        var qtyWrap = card.querySelector('[data-kit-addon-qty]');
        if (qtyWrap) {
          var input = qtyWrap.querySelector('input');
          if (input) input.value = qty;
          qtyWrap.classList.toggle('is-disabled', !on);
        }
        var priceEl = card.querySelector('[data-kit-addon-price]');
        if (priceEl && DATA.showPrices) priceEl.textContent = money(opt.priceCents);
        card.querySelectorAll('[data-kit-alt]').forEach(function (p) {
          p.classList.toggle('is-active', parseInt(p.getAttribute('data-kit-alt'), 10) === (state.addonAlt[i] || 0));
        });
        var hint = card.querySelector('[data-kit-addon-hint]');
        if (hint && scales(a.scope)) {
          hint.textContent = on ? (hint.getAttribute('data-prefix') || '') + seats() + ' ' + (DATA.unitLabel || '') : '';
        }
        card.classList.toggle('is-selected', on);
      });
    }
    function total() {
      var t = COMPUTED && state.variant.priceCents <= 0 ? 0 : state.variant.priceCents;
      DATA.included.forEach(function (line, i) {
        var u = chargeUnits(line, i);
        if (u > 0) t += (COMPUTED ? lineOpt(i).priceCents : line.priceCents) * u;
      });
      DATA.addons.forEach(function (a, i) {
        var q = state.addons[i] || 0;
        if (q) t += addonOpt(i).priceCents * q;
      });
      return t;
    }
    function renderSummary() {
      var s = root.querySelector('[data-kit-summary]');
      if (s) {
        var html = '';
        if (COMPUTED) {
          html += '<div class="kit-summary__row"><span>' + esc(DATA.title) + ' \u2014 ' + state.seatCount + ' ' + esc(DATA.unitLabel || 'units') + '</span><span>' + (state.variant.priceCents > 0 && DATA.showPrices ? money(state.variant.priceCents) : '') + '</span></div>';
          DATA.included.forEach(function (line, i) {
            var q = state.lineQty[i] || 0;
            if (!line.variantId) { html += '<div class="kit-summary__row"><span>' + esc(line.title) + '</span><span>Included</span></div>'; return; }
            if (!q) return;
            var opt = lineOpt(i);
            html += '<div class="kit-summary__row"><span>' + esc(opt.title) + ' \u00d7' + q + '</span><span>' + (DATA.showPrices ? money(opt.priceCents * q) : '') + '</span></div>';
          });
        } else {
          html += '<div class="kit-summary__row"><span>' + esc(state.variant.title) + '</span><span>' + (DATA.showPrices ? money(state.variant.priceCents) : '') + '</span></div>';
          var over = state.seatCount - tierSeats();
          if (over > 0) html += '<div class="kit-summary__row"><span>+' + over + ' ' + esc(DATA.unitLabel || 'units') + '</span><span></span></div>';
          DATA.included.forEach(function (line, i) {
            var u = chargeUnits(line, i);
            if (!u) return;
            html += '<div class="kit-summary__row"><span>Extra ' + esc(line.title) + ' \u00d7' + u + '</span><span>' + (DATA.showPrices ? money(line.priceCents * u) : '') + '</span></div>';
          });
        }
        DATA.addons.forEach(function (a, i) {
          var q = state.addons[i] || 0;
          if (!q) return;
          var opt = addonOpt(i);
          html += '<div class="kit-summary__row"><span>' + esc(opt.title) + (a.scope === 'per_order' ? '' : ' \u00d7' + q) + '</span><span>' + (DATA.showPrices ? money(opt.priceCents * q) : '') + '</span></div>';
        });
        s.innerHTML = html;
      }
      var tEl = root.querySelector('[data-kit-total]');
      if (tEl) tEl.textContent = money(total());
      var priceEl = root.querySelector('[data-kit-price]');
      if (priceEl) priceEl.textContent = COMPUTED ? money(total()) : money(state.variant.priceCents);
      var qv = root.querySelector('[data-kit-quote-config]');
      if (qv) {
        var parts = [DATA.title + ' \u2014 ' + state.seatCount + ' ' + (DATA.unitLabel || 'units') + (COMPUTED ? ' (custom build)' : ' (' + state.variant.title + ')')];
        DATA.included.forEach(function (line, i) {
          var u = COMPUTED ? (state.lineQty[i] || 0) : chargeUnits(line, i);
          if (!u) return;
          parts.push((COMPUTED ? '' : 'Extra ') + (COMPUTED ? lineOpt(i).title : line.title) + ' x' + u);
        });
        DATA.addons.forEach(function (a, i) { if (state.addons[i]) parts.push(addonOpt(i).title + ' x' + state.addons[i]); });
        qv.value = parts.join(' | ');
      }
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    root.addEventListener('click', function (ev) {
      var tierBtn = ev.target.closest('[data-kit-tier]');
      if (tierBtn) {
        var vid = parseInt(tierBtn.getAttribute('data-variant-id'), 10);
        var v = DATA.variants.find(function (x) { return x.id === vid; });
        if (!v) return;
        state.variant = v;
        state.seatCount = parseSeats(v.title);
        state.lineAlt = {};
        initLines(true);
        root.querySelectorAll('[data-kit-tier]').forEach(function (b) { b.classList.toggle('is-active', b === tierBtn); });
        try { var url = new URL(window.location.href); url.searchParams.set('variant', vid); window.history.replaceState({}, '', url); } catch (e) {}
        renderIncluded(); renderAddons(); renderSummary();
        return;
      }
      var lalt = ev.target.closest('[data-kit-line-alt]');
      if (lalt) {
        var lrow = lalt.closest('[data-kit-line]');
        var li = parseInt(lrow.getAttribute('data-kit-line'), 10);
        state.lineAlt[li] = parseInt(lalt.getAttribute('data-kit-line-alt'), 10);
        renderIncluded(); renderSummary();
        return;
      }
      var alt = ev.target.closest('[data-kit-alt]');
      if (alt) {
        var altCard = alt.closest('[data-kit-addon]');
        var altIdx = parseInt(altCard.getAttribute('data-kit-addon'), 10);
        state.addonAlt[altIdx] = parseInt(alt.getAttribute('data-kit-alt'), 10);
        if (!(state.addons[altIdx] > 0)) state.addons[altIdx] = 1;
        renderAddons(); renderSummary();
        return;
      }
      var toggle = ev.target.closest('[data-kit-addon-toggle]');
      if (toggle) {
        var card = toggle.closest('[data-kit-addon]');
        var ai = parseInt(card.getAttribute('data-kit-addon'), 10);
        state.addons[ai] = (state.addons[ai] || 0) > 0 ? 0 : 1;
        renderAddons(); renderSummary();
        if (state.addons[ai] > 0) {
          var inp = card.querySelector('[data-kit-addon-qty] input');
          if (inp) { inp.focus(); inp.select(); }
        }
        return;
      }
      var minus = ev.target.closest('[data-kit-minus]');
      var plus = ev.target.closest('[data-kit-plus]');
      if (minus || plus) {
        var wrap = (minus || plus).parentElement;
        if (wrap.classList.contains('is-disabled')) return;
        var input = wrap.querySelector('input');
        if (!input) return;
        applyQty(input, parseInt(input.value || 0, 10) + (plus ? 1 : -1));
        return;
      }
      if (ev.target.closest('[data-kit-quote-open]')) { var d = root.querySelector('[data-kit-quote]'); if (d) d.showModal(); return; }
      if (ev.target.closest('[data-kit-quote-close]')) { var d2 = root.querySelector('[data-kit-quote]'); if (d2) d2.close(); return; }
      var thumb = ev.target.closest('[data-kit-thumb]');
      if (thumb) {
        var mainImg = root.querySelector('[data-kit-main-image]');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
        root.querySelectorAll('[data-kit-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === thumb); });
        return;
      }
      var atc = ev.target.closest('[data-kit-atc]');
      if (atc) doAtc(atc);
    });
    root.addEventListener('change', function (ev) {
      var input = ev.target;
      if (input.tagName !== 'INPUT' || input.type !== 'number') return;
      applyQty(input, parseInt(input.value || 0, 10));
    });
    function applyQty(input, q) {
      var lineRow = input.closest('[data-kit-line]');
      var addonCard = input.closest('[data-kit-addon]');
      var seatsWrap = input.closest('[data-kit-seats]');
      if (seatsWrap) {
        var minSeats = COMPUTED ? 1 : tierSeats();
        q = Math.max(minSeats, Math.min(999, isNaN(q) ? minSeats : q));
        input.value = q;
        state.seatCount = q;
        initLines(false);
        renderIncluded(); renderAddons(); renderSummary();
      } else if (lineRow) {
        var idx = parseInt(lineRow.getAttribute('data-kit-line'), 10);
        var line = DATA.included[idx];
        if (!line) return;
        if (COMPUTED) {
          q = Math.max(0, Math.min(999, isNaN(q) ? 0 : q));
          input.value = q;
          state.lineQty[idx] = q;
          state.dirty[idx] = true;
          lineRow.classList.toggle('is-selected', q !== baseline(line));
        } else {
          var base = baseline(line);
          q = Math.max(base, Math.min(base + 99, isNaN(q) ? base : q));
          input.value = q;
          state.extras[idx] = q - base;
          lineRow.classList.toggle('is-selected', q > base);
        }
        renderSummary();
      } else if (addonCard) {
        var ai = parseInt(addonCard.getAttribute('data-kit-addon'), 10);
        q = Math.max(0, Math.min(999, isNaN(q) ? 0 : q));
        state.addons[ai] = q;
        renderAddons(); renderSummary();
      }
    }
    function doAtc(atc) {
      atc.disabled = true;
      atc.textContent = 'Adding\u2026';
      var items = [{ id: state.variant.id, quantity: 1, properties: { _kit: DATA.title, _kit_units: String(state.seatCount) } }];
      DATA.included.forEach(function (line, i) {
        var u = chargeUnits(line, i);
        if (u > 0 && line.variantId) {
          var vid = COMPUTED ? lineOpt(i).variantId : line.variantId;
          items.push({ id: vid, quantity: u, properties: { _kit: DATA.title, _kit_role: COMPUTED ? 'component' : 'extra' } });
        }
      });
      DATA.addons.forEach(function (a, i) {
        var q = state.addons[i] || 0;
        if (!q) return;
        var opt = addonOpt(i);
        items.push({ id: opt.variantId, quantity: q, properties: { _kit: DATA.title, _kit_role: 'add-on' } });
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        atc.disabled = false;
        atc.textContent = atc.getAttribute('data-label') || 'Add To Cart';
        alert('Could not add to cart. Please try again.');
      });
    }
    initLines(true);
    renderIncluded();
    renderAddons();
    renderSummary();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKit);
  else initKit();
  document.addEventListener('shopify:section:load', function () {
    var r = document.querySelector('[data-kit-main]');
    if (r) delete r.dataset.kitInit;
    initKit();
  });
})();
